import * as React from 'react';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
}

/**
 * A shared Image component that provides optimizations:
 * - Lazy loading by default for better performance
 * - Async decoding to prevent blocking the main thread
 * - TypeScript support with proper props typing
 * - Required alt text for accessibility
 */
export const Image = ({
  src,
  alt,
  className,
  loading = 'lazy',
  decoding = 'async',
  ...props
}: ImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding={decoding}
      className={className}
      {...props}
    />
  );
};

export default Image;
